import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Draggable } from 'react-beautiful-dnd';

import HandleIcon from 'assets/svgs/ic-drag-handle.svg';

const Wrapper = styled.div`
  display: flex;
  width: 100%;
`;

const Handle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
`;

const DraggableWrapper = ({ id, index, children }) => (
  <Draggable key={id} draggableId={id} index={index}>
    {(draggableProvided) => (
      <Wrapper
        ref={draggableProvided.innerRef}
        {...draggableProvided.draggableProps}
      >
        <Handle {...draggableProvided.dragHandleProps}>
          <img src={HandleIcon} alt="handle drag and drop filters" />
        </Handle>
        {children}
      </Wrapper>
    )}
  </Draggable>
);

DraggableWrapper.propTypes = {
  id: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  children: PropTypes.node.isRequired,
};

export default DraggableWrapper;
